import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, UsersIcon, HeartIcon, PiggyBankIcon, GlobeIcon, BrainIcon } from 'lucide-react';
const Manual = () => {
  return <div className="bg-white py-12" data-id="element-353">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-354">
        <div className="text-center mb-12" data-id="element-355">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-356">
            Manual del Juego
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-357">
            Todo lo que necesitas saber para jugar "Tu Nueva Vida: Redescubre el
            Retiro"
          </p>
        </div>
        {/* Tabla de contenidos */}
        <div className="bg-gray-50 rounded-xl p-6 mb-12" data-id="element-358">
          <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-359">
            Contenido
          </h2>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-360">
            <a href="#objetivo" className="text-blue-600 hover:text-blue-800" data-id="element-361">
              1. Objetivo del juego
            </a>
            <a href="#estructura" className="text-blue-600 hover:text-blue-800" data-id="element-362">
              2. Estructura del juego
            </a>
            <a href="#como-se-juega" className="text-blue-600 hover:text-blue-800" data-id="element-363">
              3. Cómo se juega
            </a>
            <a href="#como-se-gana" className="text-blue-600 hover:text-blue-800" data-id="element-364">
              4. ¿Cómo se gana?
            </a>
            <a href="#versiones" className="text-blue-600 hover:text-blue-800" data-id="element-365">
              5. Versiones avanzadas
            </a>
            <a href="#consejos" className="text-blue-600 hover:text-blue-800" data-id="element-366">
              6. Consejos para facilitadores
            </a>
          </div>
        </div>
        {/* Objetivo del juego */}
        <section id="objetivo" className="mb-16" data-id="element-367">
          <div className="flex items-center mb-6" data-id="element-368">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-369">
              <BookOpenIcon className="h-6 w-6 text-blue-600" data-id="element-370" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-371">
              Objetivo del juego
            </h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500" data-id="element-372">
            <p className="text-lg text-gray-700 mb-4" data-id="element-373">
              Guiar a cada jugador a través de un viaje de descubrimiento
              personal para diseñar su mejor forma de vivir el retiro,
              explorando aspectos clave como propósito, comunidad, salud,
              finanzas y legado.
            </p>
            <p className="text-gray-700" data-id="element-374">
              Al final del juego, cada participante habrá creado un plan
              personalizado para su retiro, basado en sus valores, intereses y
              circunstancias únicas, transformando esta etapa de la vida en una
              oportunidad de crecimiento y realización.
            </p>
          </div>
        </section>
        {/* Estructura del juego */}
        <section id="estructura" className="mb-16" data-id="element-375">
          <div className="flex items-center mb-6" data-id="element-376">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-377">
              <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-378" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-379">
              Estructura del juego
            </h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-380">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-381">
              <div data-id="element-382">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-383">
                  Información general
                </h3>
                <ul className="space-y-3" data-id="element-384">
                  <li className="flex" data-id="element-385">
                    <span className="font-medium text-gray-900 mr-2" data-id="element-386">
                      Jugadores:
                    </span>
                    <span className="text-gray-700" data-id="element-387">1 a 6 personas</span>
                  </li>
                  <li className="flex" data-id="element-388">
                    <span className="font-medium text-gray-900 mr-2" data-id="element-389">
                      Duración:
                    </span>
                    <span className="text-gray-700" data-id="element-390">45 a 90 minutos</span>
                  </li>
                  <li className="flex" data-id="element-391">
                    <span className="font-medium text-gray-900 mr-2" data-id="element-392">
                      Edades:
                    </span>
                    <span className="text-gray-700" data-id="element-393">
                      45+ o cualquier persona interesada en planear su retiro
                    </span>
                  </li>
                </ul>
              </div>
              <div data-id="element-394">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-395">
                  Componentes
                </h3>
                <ul className="space-y-3" data-id="element-396">
                  <li className="flex items-start" data-id="element-397">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-398">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-399">
                      Tablero circular (representa el ciclo de vida hacia el
                      retiro)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-400">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-401">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-402">
                      6 fichas de jugador (representan diferentes arquetipos de
                      retiro)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-403">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-404">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-405">
                      Cartas de 5 categorías
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-406">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-407">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-408">1 dado</span>
                  </li>
                  <li className="flex items-start" data-id="element-409">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-410">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-411">
                      Fichas de decisión y reflexión
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-412">
                    <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-2" data-id="element-413">
                      •
                    </span>
                    <span className="text-gray-700" data-id="element-414">
                      Hoja de "Tu Plan de Vida"
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-8" data-id="element-415">
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-416">
                Categorías de cartas
              </h3>
              <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-417">
                <div className="bg-purple-50 p-4 rounded-lg" data-id="element-418">
                  <div className="flex items-center mb-2" data-id="element-419">
                    <BrainIcon className="h-5 w-5 text-purple-600 mr-2" data-id="element-420" />
                    <h4 className="font-medium text-gray-900" data-id="element-421">
                      Mentalidad y Propósito
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-422">
                    Reflexiones sobre el sentido de vida, propósito y
                    actividades significativas.
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" data-id="element-423">
                  <div className="flex items-center mb-2" data-id="element-424">
                    <UsersIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-425" />
                    <h4 className="font-medium text-gray-900" data-id="element-426">
                      Vivienda y Comunidad
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-427">
                    Opciones de vivienda, entorno y conexiones comunitarias.
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-428">
                  <div className="flex items-center mb-2" data-id="element-429">
                    <PiggyBankIcon className="h-5 w-5 text-yellow-600 mr-2" data-id="element-430" />
                    <h4 className="font-medium text-gray-900" data-id="element-431">
                      Finanzas y Futuro
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-432">
                    Planificación financiera, ingresos y gestión de recursos.
                  </p>
                </div>
                <div className="bg-red-50 p-4 rounded-lg" data-id="element-433">
                  <div className="flex items-center mb-2" data-id="element-434">
                    <HeartIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-435" />
                    <h4 className="font-medium text-gray-900" data-id="element-436">
                      Salud y Bienestar
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-437">
                    Cuidado físico y mental, hábitos saludables y prevención.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-438">
                  <div className="flex items-center mb-2" data-id="element-439">
                    <GlobeIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-440" />
                    <h4 className="font-medium text-gray-900" data-id="element-441">
                      Conexión y Legado
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-442">
                    Relaciones, impacto social y transmisión de valores.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Cómo se juega */}
        <section id="como-se-juega" className="mb-16" data-id="element-443">
          <div className="flex items-center mb-6" data-id="element-444">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-445">
              <div className="text-xl font-bold text-blue-600" data-id="element-446">3</div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-447">Cómo se juega</h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-448">
            <div className="space-y-8" data-id="element-449">
              <div data-id="element-450">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-451">
                  Fase 1: El punto de partida – "Mi Visión Actual del Retiro"
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-452">
                  Cada jugador responde en su hoja:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 pl-4" data-id="element-453">
                  <li data-id="element-454">¿Qué significa para mí el retiro hoy?</li>
                  <li data-id="element-455">¿Qué me gustaría lograr en esa etapa?</li>
                </ul>
              </div>
              <div data-id="element-456">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-457">
                  Fase 2: El Viaje – "Recorriendo el Mapa del Retiro"
                </h3>
                <ol className="list-decimal list-inside text-gray-700 space-y-2 pl-4" data-id="element-458">
                  <li data-id="element-459">Lanza el dado y avanza por el tablero.</li>
                  <li data-id="element-460">
                    Al caer en un espacio, toma una carta de la categoría
                    correspondiente.
                  </li>
                  <li data-id="element-461">
                    Lee el reto o reflexión y decide:
                    <ul className="list-disc list-inside ml-6 mt-2" data-id="element-462">
                      <li data-id="element-463">¿Aplico esta idea a mi plan?</li>
                      <li data-id="element-464">¿La cambio? ¿La rechazo?</li>
                    </ul>
                  </li>
                  <li data-id="element-465">
                    Gana fichas de decisión al superar retos o compartir
                    experiencias.
                  </li>
                </ol>
                <div className="mt-4 bg-gray-50 p-4 rounded-lg" data-id="element-466">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-467">
                    Ejemplo de carta:
                  </h4>
                  <div className="bg-white p-4 border border-gray-200 rounded" data-id="element-468">
                    <p className="font-medium text-purple-600" data-id="element-469">
                      Mentalidad y Propósito
                    </p>
                    <p className="text-gray-900 font-medium mt-2" data-id="element-470">
                      Una nueva generación de retirados vive como mentores,
                      voluntarios y emprendedores. ¿Qué rol te inspira más?
                      Diseña una actividad semanal que te acerque a ello.
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-471">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-472">
                  Fase 3: Las Decisiones Clave
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-473">
                  Cada jugador enfrentará 3 decisiones de vida (se seleccionan
                  al azar) como:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 pl-4" data-id="element-474">
                  <li data-id="element-475">
                    ¿Me mudo a una comunidad intergeneracional o sigo en mi
                    hogar?
                  </li>
                  <li data-id="element-476">
                    ¿Reinvierto parte de mis ahorros en un emprendimiento con
                    impacto?
                  </li>
                  <li data-id="element-477">
                    ¿Dono mi tiempo a una causa o escribo mi legado en un libro?
                  </li>
                </ul>
              </div>
              <div data-id="element-478">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-479">
                  Fase 4: El Plan de Vida
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-480">
                  Con base en las experiencias, cada jugador escribe su
                  "Manifiesto de Retiro":
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 pl-4" data-id="element-481">
                  <li data-id="element-482">Mis valores</li>
                  <li data-id="element-483">Mi forma ideal de vivir</li>
                  <li data-id="element-484">Dónde, con quién y para qué quiero despertar cada día</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Cómo se gana */}
        <section id="como-se-gana" className="mb-16" data-id="element-485">
          <div className="flex items-center mb-6" data-id="element-486">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-487">
              <div className="text-xl font-bold text-blue-600" data-id="element-488">4</div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-489">¿Cómo se gana?</h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-500" data-id="element-490">
            <p className="text-lg text-gray-700 mb-4" data-id="element-491">
              Este no es un juego competitivo. Se gana cuando cada jugador:
            </p>
            <ul className="space-y-3" data-id="element-492">
              <li className="flex items-start" data-id="element-493">
                <span className="bg-green-100 text-green-600 p-1 rounded-full mr-3 mt-1" data-id="element-494">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-495">
                  Define un plan de retiro con claridad y sentido.
                </span>
              </li>
              <li className="flex items-start" data-id="element-496">
                <span className="bg-green-100 text-green-600 p-1 rounded-full mr-3 mt-1" data-id="element-497">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-498">
                  Ha tomado al menos una decisión importante con intención.
                </span>
              </li>
              <li className="flex items-start" data-id="element-499">
                <span className="bg-green-100 text-green-600 p-1 rounded-full mr-3 mt-1" data-id="element-500">
                  ✓
                </span>
                <span className="text-gray-700" data-id="element-501">
                  Comparte su visión con los demás al final del juego.
                </span>
              </li>
            </ul>
          </div>
        </section>
        {/* Versiones avanzadas */}
        <section id="versiones" className="mb-16" data-id="element-502">
          <div className="flex items-center mb-6" data-id="element-503">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-504">
              <div className="text-xl font-bold text-blue-600" data-id="element-505">5</div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-506">
              Versiones avanzadas
            </h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-507">
            <div className="grid md:grid-cols-3 gap-6" data-id="element-508">
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-509">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-510">
                  Modo Colaborativo
                </h3>
                <p className="text-gray-700" data-id="element-511">
                  Los jugadores planean una comunidad de retiro ideal juntos,
                  definiendo valores compartidos y actividades comunes.
                </p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-512">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-513">
                  Modo Historias Reales
                </h3>
                <p className="text-gray-700" data-id="element-514">
                  Se incluyen perfiles reales de personas que rediseñaron su
                  retiro (como casos del evento CIAMAR) para inspirar.
                </p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-515">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-516">
                  Modo "Hijo Cuidador"
                </h3>
                <p className="text-gray-700" data-id="element-517">
                  Ideal para hijos que quieren apoyar a sus padres en su
                  transición hacia el retiro, fomentando el diálogo
                  intergeneracional.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Consejos para facilitadores */}
        <section id="consejos" className="mb-16" data-id="element-518">
          <div className="flex items-center mb-6" data-id="element-519">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-520">
              <div className="text-xl font-bold text-blue-600" data-id="element-521">6</div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-522">
              Consejos para facilitadores
            </h2>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-523">
            <div className="space-y-4" data-id="element-524">
              <div className="flex items-start" data-id="element-525">
                <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-3 mt-1" data-id="element-526">
                  1
                </span>
                <div data-id="element-527">
                  <h3 className="font-semibold text-gray-900" data-id="element-528">
                    Crea un ambiente seguro
                  </h3>
                  <p className="text-gray-700" data-id="element-529">
                    Establece un espacio de confianza donde los participantes se
                    sientan cómodos compartiendo sus reflexiones personales.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-530">
                <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-3 mt-1" data-id="element-531">
                  2
                </span>
                <div data-id="element-532">
                  <h3 className="font-semibold text-gray-900" data-id="element-533">
                    Escucha activa
                  </h3>
                  <p className="text-gray-700" data-id="element-534">
                    Presta atención a las respuestas de los participantes sin
                    juzgar, haciendo preguntas que profundicen la reflexión.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-535">
                <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-3 mt-1" data-id="element-536">
                  3
                </span>
                <div data-id="element-537">
                  <h3 className="font-semibold text-gray-900" data-id="element-538">Flexibilidad</h3>
                  <p className="text-gray-700" data-id="element-539">
                    Adapta el ritmo y las reglas según las necesidades del
                    grupo. Lo importante es la reflexión, no la mecánica
                    estricta.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-540">
                <span className="bg-blue-100 text-blue-600 p-1 rounded-full mr-3 mt-1" data-id="element-541">
                  4
                </span>
                <div data-id="element-542">
                  <h3 className="font-semibold text-gray-900" data-id="element-543">
                    Cierre significativo
                  </h3>
                  <p className="text-gray-700" data-id="element-544">
                    Al finalizar, dedica tiempo para que cada participante
                    comparta sus principales descubrimientos y próximos pasos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Botones de acción */}
        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4" data-id="element-545">
          <Link to="/juego" className="bg-blue-600 text-white hover:bg-blue-700 px-6 py-3 rounded-lg font-medium text-center" data-id="element-546">
            Probar el juego
          </Link>
          <Link to="/biblioteca" className="bg-gray-100 text-gray-700 hover:bg-gray-200 px-6 py-3 rounded-lg font-medium text-center" data-id="element-547">
            Explorar recursos adicionales
          </Link>
        </div>
      </div>
    </div>;
};
export default Manual;